<template>
    <div
        class="flex flex-col p-4 flex-1 min-h-0 gap-6 border-t-4"
        :class="isActive ? 'border-green-600 bg-card' : 'border-transparent opacity-50 bg-black'"
    >
        <div class="flex-1 min-h-0 grid grid-cols-2 grid-rows-1 items-center w-full overflow-hidden">
            <SegmentsCurrentTargetText
                :target-segment="targetSegment"
                :number-only="true"
                :show-next="false"
                :current-round="currentRound"
                :total-rounds="totalRounds"
            />
            <SegmentsDartboard
                :active-segment="targetSegment"
                :next-segment="nextSegment"
                :third-segment="thirdSegment"
                :show-full-segment="true"
                class="min-h-0 h-full w-full block"
            />
        </div>
        <div class="grid grid-cols-2 items-end">
            <div class="flex flex-col h-full justify-between">
                <SegmentPlayerCard :player="player" :is-active="isActive" />
                <SegmentsPointsProgress :score="score" :ceiling="ceiling" :inline="ceiling == null"/>
            </div>
            <SegmentsHitBreakdown :darts="darts" class="justify-end" />
        </div>
    </div>
</template>

<script>
import SegmentsDartboard from '@/components/games/segments/SegmentsDartboard.vue'
import SegmentPlayerCard from '@/components/games/segments/SegmentsPlayerCard.vue'
import SegmentsCurrentTargetText from '@/components/games/segments/SegmentsCurrentTargetText.vue'
import SegmentsPointsProgress from '@/components/games/segments/SegmentsPointsProgress.vue'
import SegmentsHitBreakdown from '@/components/games/segments/SegmentsHitBreakdown.vue'

export default {
    name: 'PointsGridPlayer',
    components: {
        SegmentsDartboard,
        SegmentPlayerCard,
        SegmentsCurrentTargetText,
        SegmentsPointsProgress,
        SegmentsHitBreakdown,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        // The team's running point total this leg (folds in live darts when active).
        score: {
            type: Number,
            default: 0,
        },
        currentRound: {
            type: Number,
            default: 1,
        },
        totalRounds: {
            type: Number,
            default: 1,
        },
        // Points ceiling to fill (Ceiling mode), or null in Rounds mode.
        ceiling: {
            type: Number,
            default: null,
        },
        // The current target segment, plus the next two, for the dartboard.
        targetSegment: {
            type: Object,
            default: null,
        },
        nextSegment: {
            type: Object,
            default: null,
        },
        thirdSegment: {
            type: Object,
            default: null,
        },
        // Darts thrown this leg, for the hit breakdown.
        darts: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
